import React, { createContext } from 'react';
import { useProductFilters } from '../hooks/useProductsFilters';

const ProductFilterContext = createContext<ReturnType<
  typeof useProductFilters
> | null>(null);

export const ProductFilterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const filterState = useProductFilters();
  return (
    <ProductFilterContext.Provider value={filterState}>
      {children}
    </ProductFilterContext.Provider>
  );
};

export const useProductFilterContext = () => {
  const ctx = React.useContext(ProductFilterContext);
  if (!ctx) {
    throw new Error('useProductFilterContext must be used within provider');
  }
  return ctx;
};
